export default __webpack_public_path__ + "static/media/Jabalpur-Bandhavgarh-package.59a4062c.jpg";